import script from "./StickyBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./StickyBar.vue?vue&type=script&setup=true&lang=ts"

import "./StickyBar.vue?vue&type=style&index=0&id=355b5210&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355b5210"]])

export default __exports__